import {
  type ArticleItemType,
  Country,
  type OrderPickupContainer,
  type OtherItem,
} from '@sr/types';

const se_container_images: [string, string[]][] = [
  ['karl_190L', ['8', '79', '16', '008', '063']],
  ['karl_660L', ['11', '011']],
  ['karl_370L', ['9', '009']],
  ['pall', ['110', '4051', '090']],
  ['reisswolf_standard', ['4019', '4007', '4008', '483', '563']],
  ['lockringsfat_200L', ['1343', '57', '4843', '4844', '196', '043']],
  ['lockringsfat_60l_plast', ['100']],
  ['recytainer_800L', ['1023', '167']],
  ['oppen_container_14kbm', ['19', '018']],
  ['flak_med_lock', ['25', '019']],
  ['ibc', ['164', '1552', '104']],
  ['recytainer_250L', ['1116', '182']],
  ['reisswolf_small', ['4005', '4006', '4024']],
  ['rw_xlarge', ['4003']],
  ['sackstall', ['60', '046']],
  ['back_20-30L', ['1543', '1223', '190']],
  ['sprundfat', ['1363', '4845', '4846', '197']],
  ['wellvagn', ['15', '015']],
  ['flak_22kbm', ['26', '020']],
  ['container_kombi_8kbm', ['904', '162', '903', '803']],
  ['oppen_container_12kbm', ['43', '17', '031', '016', '18', '31', '67', '63', '303']],
  ['lastvaxlarflak_35kbm_tak', ['4865', '3009', '71', '4866', '4867', '3243', '3783']],
  ['container_27kbm', ['353']],
  ['batteribox', ['0', '001']],
  ['container_tackt_10kbm', ['59', '44', '045', '032']],
  ['container_frontlastare_8kbm', ['121', '098']],
  ['lysrorsbag', ['116', '3968', '093']],
  ['bergslofslada', ['1863', '544', '242', '127']],
  ['miljoskap_2fat', ['2683']],
  ['lysrorskista', ['115', '092']],
  ['plastdunk', ['3644', '313', '1545']],
  [
    'baktommande_container',
    ['3856', '3863', '3865', '643', '1263', '357', '743', '723', '59', '2803'],
  ],
  ['plastfat', ['4840', '102']],
  ['mobil_komprimator', ['4325', '537']],
  ['batterikasse_rod', ['EMB33']],
  ['papplada_adr_38l', ['238', '1823']],
];

const no_container_images_data: [string, string[]][] = [
  ['karl_190L', ['9107', '9108', '9109', '9110', '9111', '9114', '9129']],
  ['karl_660L', ['9121', '9122', '9123', '9124', '9116']],
  ['karl_370L', ['9112', '9113']],
  ['pall', ['9130', '9852', '9864']],
  ['lockringsfat_200L', ['9835']],
  ['oppen_container_14kbm', ['9330']],
  ['flak_med_lock', ['9370']],
  ['ibc', ['9839', '9861', '9870', '9872', '9873', '9874']],
  ['sprundfat', ['9834']],
  ['flak_22kbm', ['9340']],
  ['container_kombi_8kbm', ['9332', '9335']],
  ['oppen_container_12kbm', ['9308']],
  ['batteribox', ['9841']],
  ['container_tackt_10kbm', ['9312']],
  ['lysrorsbag', ['9864']],
  ['bergslofslada', ['9146', '9147']],
  ['miljoskap_2fat', ['9403', '9405', '9851', '9863']],
  ['lysrorskista', ['9855', '9117']],
  ['baktommande_container', ['9230', '9336']],
  ['batterikasser_lilla', ['9859']],
  ['batterikasse_gra', ['9880']],
  ['lukket_krokcontainer', ['9342', '9346', '9350', '9362']],
  ['lagercontainer', ['9420', '9422']],
  ['plastfat', ['9836']],
  ['no-ee-bur', ['9856', '9857']],
];

const confidential_data: [string, string[]][] = [
  ['karl_190L', ['110', '102']],
  ['karl_370L', ['113']],
  ['pall', ['118']],
  ['reisswolf_standard', ['111']],
  ['reisswolf_small', ['101']],
  ['rw_300', ['112']],
  ['rw_xlarge', ['108', '109']],
  ['rw_large', ['104']],
];

const dk_images: [string, string[]][] = [
  ['plastfat', ['840015', '841235']],
  ['dk/plastfat_60', ['840010']],
  ['dk/plastspuns', ['840020']],
  ['dk/dunk_20l', ['840035', '880695', '880678', '880680']],
  ['dk/dunk_25l', ['840040', '880735']],
  ['dk/glaskasse_stor', ['840045']],
  [
    'karl_660L',
    ['840060', '841450', '846696', '841430', '841460', '840075', '840315', '840187', '840062'],
  ],
  ['ibc', ['840110']],
  ['batterikasse_gra', ['840140', '840310']],
  ['sprundfat', ['840170', '840275', '840025', '840280']],
  ['lockringsfat_200L', ['840175']],
  ['dk/container_box_tackt', ['840225', '840480']],
  ['lukket_krokcontainer', ['841455', '844800', '845000']],
  ['karl_190L', ['841480']],
  ['flak_22kbm', ['844600']],
  ['dk/lukket_container_sidelag', ['845590']],
  ['dk/midicontainer', ['846810']],
  ['dk/midicontainer_10_12', ['846830', '846840']],
  ['dk/midicontainer_16', ['846860']],
  ['dk/grabkasse_hog', ['846100']],
  ['dk/grabkasse_hog_vippelag', ['846115']],
  ['dk/plastickasee', ['846130', '846135']],
  ['dk/mobil_komprimator', ['845850', '840145', '845855', '845845']],
  ['dk/daka_kar_525', ['841488']],
  ['dk/daka_minicont_120', ['841486']],
  ['dk/daka_minicont_240', ['841485']],
];

const fi_container_images: [string, string[]][] = [
  ['karl_190L', ['60120', '60140', '60240', '60250VS']],
  ['karl_660L', ['60660']],
  ['karl_370L', ['60360']],
  ['pall', ['60800', '60820', '60821', '60850']],
  ['lockringsfat_200L', ['60029', '60030', '60030A', '60030K', '60030PK']],
  ['recytainer_800L', ['60033']],
  ['flak_med_lock', ['60806', '60806K', '60807', '60807K']],
  ['ibc', ['60006', '60006UN']],
  ['sackstall', ['60018']],
  ['back_20-30L', ['60036', '60035', '60037', '60034']],
  ['flak_22kbm', ['60804', '60814', '60805']],
  ['miljoskap_2fat', ['60080']],
  ['batterikasse_gra', ['60016']],
  ['lagercontainer', ['60802']],
  ['rullako', ['60001']],
  ['hakki', ['60003']],
  ['loisteputkiastia_muovinen', ['60027']],
  ['kiintoainekontti_1000L', ['60070']],
  ['teraslaatikko', ['60071', '60072', '60073']],
  ['loisteputkiastia_pahvinen', ['60711']],
  ['VAK_laatikko', ['60037']],
];

export const getContainerImageFileName = (containerId: string, country: Country) => {
  const fileName = findFileName(containerId, country);

  return fileName;
};

export const getContainerUrl = (assetsUrl: string, country: Country, containerId?: string) => {
  if (containerId === 'other_1' || containerId === 'other_2') {
    return `${assetsUrl}/container_images/trashCanWheels.svg`;
  }

  const fileName = getContainerImageFileName(containerId ?? '', country);

  if (fileName) {
    return `${assetsUrl}/container_images/${fileName}.png`;
  }

  return `${assetsUrl}/container_images/no_image.svg`;
};

const containerDatasetsByCountry: Partial<Record<Country, [string, string[]][]>> = {
  [Country.CONFIDENTIAL]: confidential_data,
  [Country.DENMARK]: dk_images,
  [Country.FINLAND]: fi_container_images,
  [Country.SWEDEN]: se_container_images,
  [Country.NORWAY]: no_container_images_data,
};

const findFileName = (containerId: string, country: Country): string | undefined => {
  const datasets = containerDatasetsByCountry[country];

  if (!datasets) return;

  for (const [filename, ids] of datasets) {
    if (ids.includes(containerId)) return filename;
  }
};

export const getContainerIdFromArticle = (
  article: ArticleItemType | OtherItem,
  country: Country,
) => {
  const isSwedish = country === Country.SWEDEN;
  const isNorwegian = country === Country.NORWAY;
  const isConfidential = country === Country.CONFIDENTIAL;
  const isDanish = country === Country.DENMARK;
  const isFinnish = country === Country.FINLAND;

  if (article.id === 'other') {
    return article.id;
  }

  if (!isArticleItem(article)) {
    return '';
  }

  if (isConfidential) {
    const containers = article.containers;

    return containers?.[0]?.ContainerTypeId ?? '';
  } else if (isSwedish) {
    if (!hasContainerIdentifiers(article.orderInfo)) {
      return '';
    }

    return article.orderInfo.ContainerTypeId || article.orderInfo.ContainerId;
  } else if (isNorwegian || isFinnish || isDanish) {
    if (!hasItemNumber(article.orderInfo)) {
      return '';
    }

    return article.orderInfo.ItemNo.split('-')[0];
  }

  return '';
};

export const getContainerIdFromContainer = (container?: OrderPickupContainer) => {
  if (!container) {
    return 'other';
  }

  return container.ContainerTypeId ?? container.id;
};

const isArticleItem = (article: ArticleItemType | OtherItem): article is ArticleItemType => {
  return 'orderInfo' in article;
};

const hasContainerIdentifiers = (
  orderInfo: ArticleItemType['orderInfo'],
): orderInfo is Extract<
  ArticleItemType['orderInfo'],
  { ContainerTypeId: string | null; ContainerId: string | null }
> => {
  return 'ContainerTypeId' in orderInfo && 'ContainerId' in orderInfo;
};

const hasItemNumber = (
  orderInfo: ArticleItemType['orderInfo'],
): orderInfo is Extract<ArticleItemType['orderInfo'], { ItemNo: string }> => {
  return 'ItemNo' in orderInfo;
};
